import React, { useEffect } from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

let scrollCount = 0;

const ScrollToRequired = ({ fields, containerDiv, onChange }) => {

  useEffect(() => {
    scrollCount = 0;
    return () => { };
  }, []);

  const currentIndex = fields.findIndex(x => x.inFocus);
  const dir = {
    NEXT: 0,
    PREV: 1
  };

  const gotoElement = i => {
    fields[i].scrollFunc(fields[i].element, containerDiv);
    if (onChange && currentIndex) onChange(fields[currentIndex]?.id, fields[i].id);
  };

  const findFirst = d => {
    let subArray = [];
    let subIndex;
    switch(d) {
      case dir.NEXT: {
        subArray = fields.slice(currentIndex + 1);
        subIndex = subArray.findIndex(f => !f.valid);
        return subIndex === -1 ? fields.findIndex(f => !f.valid) : currentIndex + subIndex + 1;
      }
      case dir.PREV: {
        subArray = fields.slice(0, currentIndex).reverse();
        subIndex = subArray.findIndex(f => !f.valid);
        if (subIndex === -1) {
          subIndex = fields.slice().reverse().findIndex(f => !f.valid);
          if (subIndex !== -1) return fields.length - subIndex - 1;
        }
        return subIndex === -1 ? subIndex : currentIndex - subIndex - 1;  
      }
    }
  };

  const next = () => {
    scrollCount += 1;
    const nextIndex = findFirst(dir.NEXT);
    if (nextIndex >= 0 && nextIndex < fields.length) gotoElement(nextIndex);
  };
  
  const prev = () => {
    scrollCount += 1;
    const prevIndex = findFirst(dir.PREV);
    if (prevIndex >= 0 && prevIndex < fields.length) gotoElement(prevIndex);
  };

  const areAllValid = () => fields.every(f => f.valid);

  return (
    <div className="scroll-to-required-container">
      <IconButton title="Previous Required Field" color="primary" onClick={prev} disabled={scrollCount < 2 || areAllValid()}><Icon>expand_less</Icon></IconButton>
      <IconButton title="Next Required Field" color="primary" onClick={next} disabled={areAllValid()}><Icon>expand_more</Icon></IconButton>
    </div>
  );
};

ScrollToRequired.propTypes = {
  /*
  [
    {
      id: Any unique string to identify the element
      element: Can be a DOM element or a ref (Can't use scrollMethod SCROLL_TO with ref),
      scrollFunc: 
        scrollToRequired_Focus - the element should have a callable focus func
                                 Default method.
        scrollToRequired_ScrollTo - Should only be used when the element cannot be scrolled to using FOCUS.
                                    Won't focus but will only scroll to the element (Used for DATA_TYPE_RADIO / DATA_TYPE_CHECKBOX).
                                    The element SHOULD BE a DOM element ONLY. 
                                    ContainerDiv is required.
      valid: Has validation error or not (Is updated during run time)
      inFocus: The DOM element/ref that is active at the moment (will be used to determine next/prev)
    }
  ]
  */
  fields: PropTypes.array.isRequired,

  // Provide this if one of the fields is implementing scrollToRequired_ScrollTo
  containerDiv: PropTypes.element,

  // onChange(prevElement, currentElement) - Provide an onChange function. Can be used to keep track of the element in focus (when the element does not have a focus function to call for eg. react-md selection control)
  onChange: PropTypes.func,
};

export const scrollToRequired_Focus = (e) => scrollCount === 1 ? e.props.onFocus() : e.focus();
export const scrollToRequired_ScrollTo = (el, containerDiv) => containerDiv.scrollTo(0, el.offsetTop - containerDiv.offsetTop - (containerDiv.offsetHeight - el.offsetHeight)/2);

export default ScrollToRequired;